import SVG from "../../../Components/SVG";
import TableLoading from "../../../Components/Loader/TableLoading";
import { toJalaliDateTime } from "../../../helper/toJalaliDateTime";
import TradeHistoryGridCard from "./TradeHistoryGridCard";

const formatPriceTrimmed = (value) => {
  const num = Number(value);
  return Number.isFinite(num)
    ? num.toLocaleString("en-US", { maximumFractionDigits: 18 })
    : "-";
};

const formatMoney = (value) => {
  const num = Number(value);
  return Number.isFinite(num)
    ? Number(num.toFixed(2)).toLocaleString()
    : "-";
};

export default function TradeHistoryGrid({ accountData, accLoading }) {
  if (accLoading) {
    return (
      <div className="flex w-full items-center justify-center gap-2">
        <p className="text-[#808080]">در حال بارگذاری</p>
        <TableLoading className="text-[#808080]" />
      </div>
    );
  }

  if (!accountData?.trades?.length) {
    return (
      <div className="w-full flex justify-center items-center flex-col gap-5">
        <p className="text-zi-text-light dark:text-zi-text-dark text-sm sm:text-base">
          موردی برای نمایش وجود ندارد
        </p>
        <SVG name="noData" classname="w-24 fill-cyan-500" />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-4 max-h-[calc(100dvh-306px)] overflow-y-auto">
      {accountData.trades.map((trade) => {
        const pnl = Number(trade.profit_loss);

        return (
          <TradeHistoryGridCard
            key={trade.id}
            tradeType={trade.side === "long" ? "Buy" : "Sell"}
            orderType={trade.order_type}
            symbol={trade.symbol?.toUpperCase?.() ?? "-"}
            volume={`${formatMoney(trade.margin_usdt)} USDT`}
            pnl={
              pnl >= 0
                ? `$${formatMoney(pnl)}`
                : `-$${formatMoney(Math.abs(pnl))}`
            }
            openPrice={`$${formatPriceTrimmed(trade.entry_price)}`}
            openTime={toJalaliDateTime(trade.opened_at)}
            closePrice={`$${formatPriceTrimmed(trade.exit_price)}`}
            closeTime={toJalaliDateTime(trade.closed_at)}
          />
        );
      })}
    </div>
  );
}
